import {
  BookingRequestResponse,
  OrganizerPortalEvent,
  PROMOTION_BASE_TIER,
  activePromotion,
  promotionCoversEvent,
} from '@radevents/shared';

/**
 * Die offene Hervorhebungs-Anfrage zu diesem Event, falls es eine gibt.
 *
 * Ohne diese Anzeige fragt man dasselbe Event ein zweites Mal an — die Redaktion hätte dann zwei
 * Anfragen zu einer Card und wüsste nicht, welche gilt. Der Server weist die zweite ohnehin ab
 * (`countOpenPromotionsForEvent`); hier steht sie, damit es gar nicht erst dazu kommt.
 */
export const openPromotionRequest = (
  bookings: BookingRequestResponse[],
  eventId: number,
): BookingRequestResponse | undefined =>
  bookings.find(b => b.eventId === eventId
    && b.kind === 'PROMOTION'
    && b.status === 'OPEN');

/**
 * Was an diesem Event an Hervorhebung noch zu kaufen ist — `null`, wenn nichts.
 *
 * Läuft die Buchung schon bis zur Veranstaltung, gibt es an Laufzeit nichts mehr; dann bleibt nur
 * der Wechsel vom Rahmen zur dunklen Card. Läuft die schon, ist alles erledigt — die Bühne steht
 * seit dem 11.09.2026 nicht mehr im Angebot. Ein Knopf, der in eine Sackgasse führt, ist
 * schlimmer als keiner.
 *
 * Steht **an einer Stelle**, weil zwei Reiter dieselbe Entscheidung treffen: *Meine Events* am
 * Termin und *Sichtbarkeit & Promotion* in seiner Event-Liste. Zwei Kopien liefen auseinander, sobald
 * eine gepflegt wird — genau die Sorge, die dort lange einen zweiten Buchungsweg verhindert hat.
 */
export const promoActionLabel = (entry: OrganizerPortalEvent): string | null => {
  if (entry.event.status !== 'PUBLISHED') return null;
  // Ein gelaufenes Event hervorzuheben verkauft Sichtbarkeit fuer einen Termin, den es nicht mehr
  // gibt. Seit gelaufene Events ohne neuen Termin in der Liste stehen bleiben (nextEditionDue),
  // stuende der Knopf dort sonst an jedem von ihnen.
  const last = entry.event.endDate || entry.event.eventDate;
  if (last < new Date().toISOString().slice(0, 10)) return null;
  const promo = activePromotion(entry.event);
  if (!promo) return 'Hervorheben';
  if (!promotionCoversEvent(entry.event)) return 'Verlängern';
  return promo.tier === PROMOTION_BASE_TIER ? 'Stärker hervorheben' : null;
};
